// Thin wrapper around window.umami, the self-hosted Umami script vite.config.js's
// transformIndexHtml plugin injects into index.html only when
// VITE_UMAMI_WEBSITE_ID is set at build time. A no-op everywhere that script
// is absent — local dev, a build without the env var, an ad blocker — so call
// sites never have to check for window.umami themselves.
export function track(name, data) {
  try {
    window.umami?.track(name, data);
  } catch {
    // Analytics must never break the product it is watching.
  }
}
